export default {"src":"/_next/static/media/klarna.f6ca3dc0.svg","height":25,"width":45};